import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DefaultLayoutComponent } from './containers';
import { AuthGuardService } from './common-service/auth-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./views/pages/pages.module').then((m) => m.PagesModule)
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    canActivate: [AuthGuardService],
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./views/dashboard/dashboard.module').then((m) => m.DashboardModule)
      },
      {
        path: 'master',
        loadChildren: () =>
          import('./views/masterpage/master.module').then((m) => m.MasterModule)
      },
      {
        path: 'product',
        loadChildren: () =>
          import('./views/product-master/product.module').then((m) => m.ProductModule)
      },
      {
        path: 'deliverychallan',
        loadChildren: () =>
          import('./views/delivery-challan/delivery-challan.module').then((m) => m.DeliveryChallanModule)
      },
      {
        path: 'purchase',
        loadChildren: () =>
          import('./views/purchasmaster/purchase.module').then((m) => m.PurchaseModule)
      },
      {
        path: 'payment',
        loadChildren: () =>
          import('./views/paymentsvoucher/payment.module').then((m) => m.PaymentModule)
      },
      {
        path: 'sales',
        loadChildren: () =>
          import('./views/sale/sale.module').then((m) => m.SaleModule)
      },
      {
        path: 'orders',
        loadChildren: () =>
          import('./views/orders/orders.module').then((m) => m.OrdersModule)
      },
      {
        path: 'gstmain',
        loadChildren: () =>
          import('./views/gst/gst.module').then((m) => m.GstModule)
      },
    ]
  },

  { path: '**', redirectTo: 'dashboard' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking'
      // relativeLinkResolution: 'legacy'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
